import { Component } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { PanelModule } from '../../../modules/panel.module';
import { PromotionService } from '../../../services/promotion.service';
import { BusinessListComponent } from '../../business/business-list/business-list.component';
import { Promotion } from '../../../model/promotion.model';

@Component({
  selector: 'brt-promotion-list',
  standalone: true,
  imports: [PanelModule, BusinessListComponent],
  providers: [ConfirmationService],
  templateUrl: './promotion-list.component.html',
  styleUrl: './promotion-list.component.scss'
})
export class PromotionListComponent {
  basePath = this.route.snapshot.data['basePath'] || '/';
  constructor(public router: Router, private route: ActivatedRoute, private promotionService: PromotionService) {
    route.params.subscribe(async params => {
      this.criteria = { BusinessId: params['bid'] };
    });
  }

  loading: boolean = true;
  promotions: Promotion[];
  total: number;
  criteria: any = {};
  async load(event?: any) {
    if (!this.criteria.BusinessId) return
    this.loading = true;

    this.criteria = {
      BusinessId: this.criteria.BusinessId,
      From: event?.first || 0,
      Size: event?.rows || 100
    };

    var result = await this.promotionService.searchPromotion(this.criteria);
    this.promotions = result.List;
    this.total = result.Total;
    this.loading = false;
  }

  async setOrder() {
    var indexes: { [id: string]: number } = {};
    for (var i = 0; i < this.promotions.length; i++) {
      let index = this.criteria.From + i;
      if (this.promotions[i].Order != index)
        indexes[this.promotions[i].Id] = index;
    }
    await this.promotionService.setPromotionIndex(indexes);
  }

  async removePromotion(promotion: Promotion) {
    try {
      if(!confirm(`Are you sure you want to delete promotion "${promotion.Name}"?`)) return;
      this.loading = true;
      await this.promotionService.deletePromotion(promotion.Id);
    } finally {
      this.loading = false;
    }
    await this.load();
  }
}
